import React, { useEffect, useState } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { MdModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import addressModel from "../../model/address.model";
import back from "../../Asset/product/back.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Addresspop = ({
  setModel,
  setAddress,
  selectedIndex,
  setSelectedIndex,
}) => {
  const [listData, setListData] = useState();
  const [loading, setLoading] = useState(false);

  const Navigate = useNavigate();

  const GetList = async () => {
    setLoading(true);
    addressModel
      .GetAddress()
      .then((responce) => {
        setListData(responce?.data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  useEffect(() => {
    GetList();
  }, []);
 useEffect(() => {
    AOS.init();
  }, []);
  return (
    <div
      className="w-full bg-black/50 fixed inset-0 flex justify-center items-center z-50"

      onClick={() => {
        setModel(false);
      }}
    >
      <div
        className="bg-Background1 p-5 md:w-1/2 w-full rounded-3xl"
        data-aos="flip-up"
         style={{
        backgroundImage: `url(${back})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between mb-5">
          <span className="text-lg text-textColor"
          style={{ fontFamily: "Salsa, sans-serif" }}>
            Select Addresses
          </span>
          <span className="text-3xl">
            <IoCloseCircle
              className="cursor-pointer"
              onClick={() => {
                setModel(false);
              }}
            />
          </span>
        </div>
        {loading ? (
          <div className="w-full  flex items-center justify-center gap-3">
            <span className="loading loading-ring loading-xs"></span>
            <span className="loading loading-ring loading-sm"></span>
            <span className="loading loading-ring loading-md"></span>
            <span className="loading loading-ring loading-lg"></span>
            <span className="loading loading-ring loading-xl"></span>
          </div>
        ) : (
          <div className="p-4">
            {listData && listData.length > 0 ? (
              listData.map((item, index) => (
                <div className="flex flex-col" key={index}>
                  <div className="flex justify-between w-full">
                    <div className="flex gap-5">
                      <div className="flex justify-center items-center">
                        <div
                          className="p-1 border-4 border-Background6 rounded-full cursor-pointer"
                          onClick={() => {
                            setSelectedIndex(index);
                            setAddress(item);
                            setModel(false);
                          }}
                        >
                          <div
                            className={`p-1 ${
                              selectedIndex === index ? "bg-[#AAC39E]" : ""
                            } rounded-full cursor-pointer`}
                          ></div>
                        </div>
                      </div>
                      <div>
                        <div>
                          <span className="px-3 title1 text-[12px] py-1 bg-Background2 text-textColor rounded-lg font-semibold">
                            {item?.address_type}
                          </span>
                        </div>
                        <div className="mt-2 title2 text-sm">
                          <p>
                            {item.house_number} {item?.society_name}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="bg-textColor text-white rounded-full cursor-pointer" onClick={()=>{
                        Navigate(`/editaddress/${item?._id}`)
                      }}>
                        <MdModeEdit className="text-3xl p-2" />
                      </div>
                    </div>
                  </div>
                  <hr className="my-3 h-0.5 bg-Background2" />
                </div>
              ))
            ) : (
              <div className="text-center text-gray-500 text-sm ">
                No Address Found
              </div>
            )}
          </div>
        )}
        <div className="w-full flex justify-end px-4 cursor-pointer">
          <span
            className="text-[14px] title1 font-semibold bg-textColor text-white px-6 py-1.5 rounded-3xl"
            onClick={() => {
              Navigate("/addaddress");
            }}
          >
            Add New Address
          </span>
        </div>
      </div>
    </div>
  );
};

export default Addresspop;
